import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { addDoc, collection, doc, getDocs, query, setDoc, where } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { auth, firebaseField, firestore } from "../../../firbase.config";
import { consultarConfiguracion, consultarEmpresa } from "../../../utilities/general";


export const getCompanyInfo = createAsyncThunk(
    "company/getCompanyInfo",
    async (post) => {

    }
);

export const getCuenta = createAsyncThunk(
    "company/getCuenta",
    async (post) => {
        const cuenta = await consultarConfiguracion('MAX_COMPANY_ID');
        //    console.log("getCuenta", cuenta)
        return cuenta
    }
);

export const createCompany = createAsyncThunk(
    "company/createCompany",
    async (post) => {

        const { companyUser, imageFile } = post;
        let dbCompanyId = false;
        const cuenta = await consultarConfiguracion('MAX_COMPANY_ID');

        const queryData = query(collection(firestore, "company"), where("documento", "==", companyUser.numDoc));
        let documentExist = false;

        const querySnapshot = await getDocs(queryData);
        querySnapshot.forEach((doc) => {
            documentExist = true;
            throw new Error(`El documento ${companyUser.numDoc}, ya está relacionado con una cuenta`)
        });

        dbCompanyId = companyUser.tipoDoc + companyUser.numDoc;
        let dbCompany = {}
        const uid = await createUserWithEmailAndPassword(auth, companyUser.correo, companyUser.password);


        await sendEmailVerification(uid.user);

        await setDoc(doc(firestore, "configuration", 'MAX_COMPANY_ID'), { id: cuenta.id + 1 });

        if (imageFile) {
            const storage = getStorage();
            const spaceRef = ref(storage, `${dbCompanyId}/avatar/${imageFile.name}`);

            await uploadBytes(spaceRef, imageFile).then((snapshot) => {
            });
            dbCompany = {
                tipo: 'company',
                nombres: companyUser.razonSocial,
                correo: companyUser.correo,
                fecha_creacion: firebaseField,
                cuenta_activa: 'No',
                tipo_documento: companyUser.tipoDoc,
                num_documento: companyUser.numDoc,
                bot_activo: false,
                ocr_activo: false,
                botonChatImg: ``,
                avatar: ``,
                logoNombre: ``,
                cuenta_nueva: true,
                botonTitle: 'Prueba tus conversaciones',
                nombre: 'Vista previa',         
                cuenta: cuenta ? `${cuenta.id + 1}` : "1",
                logo: `${process.env.REACT_APP_CHATASESORES_AVATAR_IMAGE}/${dbCompanyId}/avatar/${imageFile.name}`
            }
        } else {
            dbCompany = {
                tipo: 'company',
                botonTitle: 'Prueba tus conversaciones',
                nombre: 'Vista previa',
                nombres: companyUser.razonSocial,
                correo: companyUser.correo,
                fecha_creacion: firebaseField,
                cuenta_nueva: true,
                cuenta_activa: 'No',
                bot_activo: false,
                ocr_activo: false,
                tipo_documento: companyUser.tipoDoc,
                num_documento: companyUser.numDoc,
                cuenta: cuenta ? `${cuenta.id + 1}` : 1,
            }
        }

        await setDoc(doc(firestore, "company", dbCompanyId), dbCompany);

        const docRef = await addDoc(collection(firestore, `company/${dbCompanyId}/usuarios`), {
            nombres: companyUser.razonSocial,
            mail: companyUser.correo,
            // nickname: dbCompanyId,
            //    skill:{
            //      id: randomId,
            //    nombre: 'Habilidad General'
            // },
            rol: 'SUPERVISOR',
            uid: uid.user.uid,
            fecha_creacion: firebaseField,
        });

        const messages = `<p>¡Hola!</p> 

        <p>Te damos la bienvenida a Avanti-it. 
        A continuación te confirmo tus datos para hacer el 
        login en la aplicación.</p>

        <p>Número de empresa: ${dbCompany.cuenta}</p>
        <p>correo: ${dbCompany.correo}</p>
        <p>Contraseña: ${companyUser.password}</p>

        <p>Enlace para iniciar sesión: <a href=${process.env.REACT_APP_LOGIN}> 
        ${process.env.REACT_APP_LOGIN}</a><p>`


        const body = {
            from_: "Datos de cuenta <chatasesores@gmail.com>",
            to_: companyUser?.correo,
            subject_: "Verificación de datos cuenta Avanti-it",
            body: messages,
            user: "chatasesores@gmail.com",
            pass: "wdnwdcqgpdhwoskg"
        }

        await fetch(`${process.env.REACT_APP_CHATASESORES_SEND_MAIL}`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: { "Content-type": "application/json; charset=UTF-8" }
        })

        return {
            usuario: dbCompanyId,
            message: 'Compañia creada exitosamente',
            cuenta: dbCompany?.cuenta,
        }
    }
);

export const getCompany = createAsyncThunk(
    "company/getCompany",
    async (post) => {
        const { company } = post;
        console.log("company", company);
        const empresa = await consultarEmpresa(company);
        // Add a new document with a generated id.
        // const docRef = await addDoc(collection(firestore, "/company/alcaldiaPereira/usuarios"), usuario);
        return empresa
    }
);
export const limpiarCompany = createAction("company/limpiarCompany");